import { CAMPAGNE } from '@/configuration/parametrage/tagConf';

export default function genererTag() {
  return {
    libelle: '',
    moduleTag: CAMPAGNE,
    actif: true,
  };
}
